<template>
  <div class="center-content mt-2 mb-2">
    <div v-if="selectedOrder && order != null" class="content w-100">
      <div :class="`order-status-header ${statusClass(order.status)}`">
        <h4>
          {{ translateStatus(order.status) }}
        </h4>
      </div>
      <vue-custom-scrollbar>
        <div :style="{ display: 'none' }">
          <div id="printable-info">
            <p>
              <strong>{{ company.name }} - {{ branch.name }}</strong>
            </p>
            <br />
            <p>Informações do pedido</p>
            <p>Pedido: {{ order.seq }}</p>
            <p>Tipo: {{ translateLocation(order.locationType) }}</p>
            <p v-if="order.withdrawalTime">
              Horário da retirada: {{ order.withdrawalTime }}
            </p>
            <br />
            <p>Informações do cliente</p>
            <p v-if="user || order.totemClientName">
              Nome:
              {{
                order.noAuth
                  ? `${user.name} ( ${order.noAuthName} )`
                  : user
                  ? user.name
                  : order.totemClientName
              }}
            </p>
            <p>Telefone: {{ user && user.phone  }}</p>
            <p v-if="user && !order.noAuth">Email: {{ user.email }}</p>
            <p v-if="(user && user.cpf && !order.noAuth) || order.cpfCustomer">
              CPF: {{ user ? user.cpf : order.cpfCustomer }}
            </p>
            <p v-if="user && user.cnpj">CNPJ: {{ user.cnpj }}</p>
            <template v-if="formatAddress(order.location)">
              <br />

              <p>Informações de entrega</p>
              <p v-if="order.child.name">Filho: {{ order.child.name }}</p>
              <p v-if="order.child.grade">Ano: {{ order.child.grade }}</p>
              <p v-if="order.child.class">Turma: {{ order.child.class }}</p>
              <p v-if="order.child.shift">Turno: {{ order.child.shift }}</p>
              <p>Endereço: {{ formatAddress(order.location) }}</p>
              <p v-if="order.location.address.complement">
                Complemento: {{ order.location.address.complement }}
              </p>
              <p v-if="order.location.address.reference">
                Referência: {{ order.location.address.reference }}
              </p>
              <p v-if="order.location.address.postalCode">
                CEP: {{ order.location.address.postalCode }}
              </p>
            </template>
          </div>
        </div>

        <div class="content-scrollable">
          <b-tabs>
            <b-tab title="Pedido">
              <b-card
                v-if="order.locationType === enums.LocationTypes.TakeAway"
                title="ATENÇÃO"
              >
                <p>De forma a evitar fraude, atente-se aos seguintes pontos:</p>
                <p>
                  - No momento da retirada, o cliente deve assinar a linha
                  tracejada presente na comanda
                </p>

                <template v-if="order.paymentMethod.legend">
                  <p>
                    Este foi um pagamento online, então também siga os seguintes
                    passos:
                  </p>
                  <p>
                    - O cliente deve apresentar um documento oficial com foto
                  </p>
                  <p>
                    - O cliente deve apresentar o seguinte cartão, que foi
                    utilizado na compra: {{ order.paymentMethod.legend }}
                  </p>
                </template>
              </b-card>

              <b-card
                :title="`Pedido #${order.seq} - ${translateLocation(
                  order.locationType
                )}`"
                id="printable-payment"
              >
                <h5 v-if="order.withdrawalTime">
                  Horário da retirada: {{ order.withdrawalTime }}
                </h5>
                <p v-if="order.child.name">Filho: {{ order.child.name }}</p>
                <p v-if="order.child.grade">Ano: {{ order.child.grade }}</p>
                <p v-if="order.child.class">Turma: {{ order.child.class }}</p>
                <p v-if="order.child.shift">Turno: {{ order.child.shift }}</p>
                <p>Forma de pagamento: {{ order.paymentMethod.label }} 
                  <span v-if="order.paymentMethod.pixChecked" style="color: green">
                    <i class="las la-check-square"></i> 
                    Pagamento Verificado
                  </span>
                </p>
                <p v-if="formatAddress(order.location)">
                  Endereço: {{ formatAddress(order.location) }}
                </p>
                <p v-if="order.location.address.complement">
                  Complemento: {{ order.location.address.complement }}
                </p>
                <p v-if="order.location.address.reference">
                  Referência: {{ order.location.address.reference }}
                </p>
                <p v-if="order.location.address.postalCode">
                  CEP: {{ order.location.address.postalCode }}
                </p>
                <a
                  href=""
                  target="_blank"
                  v-show="order.appInfo"
                  @click.prevent="showAppInfo = !showAppInfo"
                >
                  Origem:
                  {{ isPlatformWeb ? "Web" : "Aplicativo" }}
                  <i class="las la-angle-up" v-if="showAppInfo" />
                  <i class="las la-angle-down" v-else />
                </a>
                <b-collapse :visible="showAppInfo">
                  <div
                    v-if="
                      order.appInfo &&
                      order.appInfo.supermenuVersion &&
                      order.appInfo.version &&
                      order.appInfo.deviceName &&
                      order.appInfo.platform
                    "
                  >
                    <p>
                      Versão do {{ nameApp  }}: {{ order.appInfo.supermenuVersion }}
                    </p>
                    <p>Versão da loja: {{ order.appInfo.version }}</p>
                    <p>Modelo do dispositivo: {{ order.appInfo.deviceName }}</p>
                    <p>Plataforma: {{ order.appInfo.platform }}</p>
                  </div>
                  <div v-else>
                    <div v-if="isPlatformWeb">PWA</div>
                    <div v-else>
                      App ainda não possui dados da versão, por favor atualizar
                    </div>
                  </div>
                </b-collapse>
              </b-card>
              <b-card                
                v-if="order.scheduledOrder && order.scheduledOrder.scheduled"
              >
              <b-card-title>Pedido agendado </b-card-title>
              <div id="printable-schedule">
                <p>
                  Data de entrega: {{new Date(order.scheduledOrder.date).toLocaleString().substring(0, 10)}}
                </p>
                <p>
                  Horário de entrega: Entre {{order.scheduledOrder.from}} e {{order.scheduledOrder.to}}
                </p>
              </div>
              </b-card>
              <b-card>
                <b-card-title>
                  <div v-if="user || order.totemClientName">
                    {{
                      order.totemClientName ||
                      `${user.name} ${
                        order.noAuthName ? "( " + order.noAuthName + " )" : ""
                      }`
                    }}
                    <a href="" target="_blank">
                      <i class="las la-bell" />
                    </a>
                  </div>
                  <div v-else>Aguarde...</div>
                </b-card-title>
                <div>
                  <p v-if="user && user.email">Email: {{ user.email }}</p>
                  <p v-if="user && user.phone">
                    Telefone:
                    <a
                      :href="shareWhatsapp(order.noAuthPhone || user.phone)"
                      target="_blank"
                    >
                      {{ order.noAuthPhone || user.phone }}
                      <i class="lab la-whatsapp"></i>
                    </a>
                  </p>
                  <p v-if="user && qtyOrders"> 
                    Quantidade de compras anteriores: {{ qtyOrders }}
                  </p>
                  <p
                    v-if="
                      !order.noAuth &&
                      user &&
                      user.loyalty.points
                    "
                  >
                    Quantidade de pontos: {{ user.loyalty.points }}
                  </p>
                  <p
                    v-if="
                      !order.noAuth && (user && user.cpf)
                    "
                  >
                    CPF: {{ order.cpfCustomer || user.cpf }}
                  </p>
                  <p v-if="user && user.cnpj">CNPJ: {{ user.cnpj }}</p>
                </div>

                <div
                  v-if="
                    !order.paid &&
                    company.prepaidEnabled &&
                    user &&
                    user.credit &&
                    user.credit.available >= getTotal(order)
                  "
                >
                  <p>
                    O cliente possui saldo disponível para cobrir a compra.
                    Deseja descontar esse valor do saldo?
                  </p>
                  <button
                    v-if="!loading"
                    @click="discountFromCredits(order, user)"
                  >
                    Descontar
                  </button>
                  <p v-else>aguarde...</p>
                </div>
              </b-card>
              <b-card>
                <OrderTable :order="order" />
              </b-card>
            </b-tab>
            <b-tab title="Comprovante" v-if="order.paymentMethod.label === 'Pix'">
              <template>
                  <br/>
                  <b-img center v-if="order.paymentMethod && order.paymentMethod.receipt" :src="order.paymentMethod.receipt" alt="" style="width: 50%"/>

                  <br/>
                  <b-checkbox
                    v-model="pixCheckBox"
                    v-if="!order.paymentMethod.pixChecked"
                  >
                    Pagamento Verificado.
                  </b-checkbox>
                  <span v-else><i class="las la-check-square" style="color: green"></i> Pagamento Verificado</span>
                  <br/>
                  <div v-if="!order.paymentMethod.pixChecked">
                    <b-input-group-append>
                      <b-button :disabled="buttonDisable" type="submit" class="custom-btn">
                        <div
                          v-if="loading"
                          class="spinner-border spinner-border-sm text-white"
                        ></div>
                        <div v-else class="text-white" @click="pixCheckedPayment()">Salvar</div>
                      </b-button>
                    </b-input-group-append>
                  </div>
                </template>
            </b-tab>
            <b-tab title="Avaliação" v-if="order.review.value">
              <b-card>
              <p><strong>Nota do pedido:</strong> {{order.review.value}} {{order.review.value > 1 ? ' estrelas' : ' estrela'}}</p>
              <p v-if="order.review.comment"><strong>Comentário:</strong> {{order.review.comment}}</p>
              </b-card>
            </b-tab>
          </b-tabs>
        </div>
      </vue-custom-scrollbar>
    </div>
    <div class="no-order-selected" v-else>
      Por favor, selecione um pedido para ver os seus detalhes
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import vueCustomScrollbar from "vue-custom-scrollbar";
import {
  orderStatus,
  couponType,
  locationType,
} from "@/helpers/translateEnums";
import { getComplementGroup } from "@/helpers/queries";
import {
  getAccessToken,
  getActiveCompany,
  getActiveBranch,
} from "@/helpers/storage";
import { discountValue, productDiscount } from "@/helpers/discount";
import { isPlatformWeb } from "@/helpers/platform";
import { addressFormatter, deliveryFee } from "@/helpers/textFormatter";
import { subtotal, orderDiscount, total } from "@/helpers/order";
import OrderTable from "@/components/Orders/OrderTable";
import { patch } from "@/network/rest";
import Locations from "@/network/locations";

export default {
  name: "bench",
  components: {
    vueCustomScrollbar,
    OrderTable,
  },
  data() {
    return {
      qtyOrders: 0,
      showAppInfo: false,
      loading: false,
      buttonDisable: false,
      pixCheckBox: false, 
      nameApp: process.env.VUE_APP_TITLE == "SolShop"  ? "solshoponline" 
      : process.env.VUE_APP_TITLE == "Klavi"? "klavi"
      : "supermenu"
    };
  },
  computed: {
    ...mapGetters({
      selectedOrder: "getSelectedOrder",
      enums: "getEnums",
    }),
    feathers() {
      return this.$FeathersVuex.api;
    },
    numOrderStatus() {
      return this.enums.OrderStatusEnum;
    },
    order() {
      const order = this.feathers.Order.getFromStore(this.selectedOrder);
      const cancelled = order && order.status === this.numOrderStatus.Cancelled;

      if (cancelled) this.clearOrder();

      console.log(order, "orders aqui");
      return cancelled ? null : order;
    },
    user() {
      return this.feathers.User.getFromStore(this.order.customer);
    },
    accessToken: () => getAccessToken(),
    numOrderStatus() {
      return this.enums.OrderStatusEnum;
    },
    activeBranch: () => getActiveBranch(),
    activeCompany: () => getActiveCompany(),
    branch() {
      return this.feathers.Branch.getFromStore(this.activeBranch);
    },
    company() {
      return this.feathers.Company.getFromStore(this.activeCompany);
    },
    isPlatformWeb() {
      return isPlatformWeb(this.order);
    },
  },
  methods: {
    ...mapActions(["clearOrder"]),
    checkOrderOk(order) {
      const info = order.orderInfo;
      const items = order.items;
      const totalItemsOk =
        items.length === info.products.length &&
        items.length === info.qtyProducts;

      if (!totalItemsOk) return false;

      items.forEach((item) => {});
    },
    toCurrency(value) {
      return this.$options.filters.currency(value);
    },
    formatAddress(location) {
      return addressFormatter(location);
    },
    categories(items) {
      let groups = [];
      items.forEach((item) => groups.push(item.complementGroup));

      const set = new Set(groups);
      groups = [...set];

      return groups;
    },
    complements(groupId, items) {
      let result = items.filter((item) => item.complementGroup === groupId);

      return result;
    },
    productDiscount(offers, offerId) {
      return productDiscount(offers, offerId);
    },
    deliveryFee(order) {
      return deliveryFee(order);
    },
    translateStatus(status) {
      return orderStatus(this, status);
    },
    translateLocation(location) {
      return locationType(this, location);
    },
    discountValue(item, offer) {
      return discountValue(this, item, offer);
    },
    complementGroup(id) {
      const complement = this.feathers.ComplementGroup.getFromStore(id);

      if (complement) {
        return complement;
      } else {
        getComplementGroup(this.feathers, this.accessToken, id);

        return null;
      }
    },
    shareWhatsapp(phone) {
      if (!phone) return;

      let number_formated = phone.replace(/[() -]/g, "");

      return `https://api.whatsapp.com/send?phone=55${number_formated}`;
    },
    statusClass(status) {
      return this.$options.filters.orderClass(status, this.numOrderStatus);
    },
    total(order) {
      return total(this, order);
    },
    orderDiscount(order) {
      return orderDiscount(this, order);
    },
    discountFromCredits(order, user) {
      this.loading = true;

      patch(this.accessToken, `${Locations.orders}/${order._id}`, {
        paid: true,
      })
        .then((r) => {
          console.log("foi aqui", r, user);
          const currentCredits = user.credit || {
            available: 0,
            history: [],
          };

          const newCredits = {
            available: currentCredits.available - this.getTotal(order),
            history: [],
          };

          patch(this.accessToken, `${Locations.customers}/${user._id}`, {
            credit: newCredits,
          })
            .then((r) => {
              this.loading = false;
            })
            .catch((e) => {
              console.log(e);

              this.loading = false;
            });
        })
        .catch((e) => {
          console.log(e);

          this.loading = false;
        });
    },
    getTotal(order) {
      return this.total(order) - this.orderDiscount(order);
    },
    async pixCheckedPayment(){

      this.buttonDisable = true;
      this.loading = true;

      const response = await patch(
        getAccessToken(),
        `manager/orders/${this.order._id}`,
        { paymentMethod: {
            kind: this.order.paymentMethod.kind,
            receipt: this.order.paymentMethod.receipt,
            label: this.order.paymentMethod.label,
            pixChecked: this.pixCheckBox
          }
        }
      );

      this.buttonDisable = false;
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
